import _extends from "@babel/runtime/helpers/extends";

/* eslint-disable max-lines */
import * as React from 'react';
import { createIcon } from '../internal'; // eslint-disable-next-line react/display-name

var IconComponent = React.forwardRef(function (props, ref) {
  return React.createElement("svg", _extends({}, props, {
    ref: ref,
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }), React.createElement("g", {
    id: "16x16/refresh"
  }, React.createElement("path", {
    id: "Union",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.9291 7H15V6V0.5H13V3.10098C11.7295 1.80445 9.9587 1 8.00003 1C4.47356 1 1.55615 3.60771 1.07092 7H3.10005C3.56332 4.71776 5.58108 3 8.00003 3C9.63585 3 11.0882 3.78555 12.0004 5H9V7H12.9H14H14.9291ZM12.9 9C12.4367 11.2822 10.419 13 8.00003 13C6.36422 13 4.91187 12.2144 3.99967 11H7V9H3.10005H2H1.07092H1V10V15.5H3V12.8989C4.27052 14.1955 6.04133 15 8.00003 15C11.5265 15 14.4439 12.3923 14.9291 9H12.9ZM15 8.02216L15 8L15 7.97784V8.02216Z",
    fill: "currentColor"
  })));
});
/**
 * Компоненты иконки <br />
 * Некоторые иконки красятся в любые цвета из палитры, некоторые имеют зафиксированные цвета.<br />
 * Подключение иконки: `import { Refresh16 } from '@cian/ui-kit/icons';`, <br />
 * где 16 - это размер иконки в пикселях.
 */

export var Refresh16 = createIcon(IconComponent);